import AddButton from 'components/buttons/AddButton'
import AdminDesignationAction from 'components/data-table/data-table-action/admin-action/AdminDesignationAction';
import DepartmentListAction from 'components/data-table/data-table-action/superadmin-actions/DepartmentListAction';
import DataTable from 'components/data-table/DataTable'
import Loader from 'components/loader/Loader';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { Col, Container, Row, Breadcrumb, BreadcrumbItem, } from 'reactstrap'
import { AdminDesignationListRes, AdminDesignationListTodo } from 'redux/slice/admin/master/designation/AdminDesignationList';
import { departmentListRes, departmentListTodo } from 'redux/slice/super-admin/master/department/DepartmentList';

 class AdminDesignationList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            bool: false
        };
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.setState({ loading: true });
       dispatch(AdminDesignationListTodo()).then(() => this.List_res());
    }

    componentDidUpdate(prevProps, prevState) {
        const { dispatch } = this.props;
        if (prevState.bool !== this.state.bool) {
          dispatch(AdminDesignationListTodo()).then(() => this.List_res());
        }
    }

    setBool = () => {
        this.setState(prevState => ({ bool: !prevState.bool }));
    }


    List_res = () => {
        if (AdminDesignationListRes?.success) {
            this.setState({ loading: false });
        }else if (AdminDesignationListRes?.error?.status == 401) {
            localStorage.clear()
            this.props.history.push('/admin/login');
        } else {
            this.setState({ loading: false });
        }
    }
    render() {

        const { loading,bool } = this.state;
        const { designationList} = this.props;
        const columnDefs = [
            {
                headerName: 'S.NO',
                valueGetter: 'node.rowIndex + 1',
                filter: 'false',
                suppressMenu: true,
                sortable: true,
                floatingFilter: false,
                maxWidth: 100
            },
            {
                headerName: 'DESIGNATION',
                field: 'name',
                filter: 'agTextColumnFilter',
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
            },
            {
                headerName: 'STATUS',
                field: 'status',
                filter: 'agTextColumnFilter',
                // cellRenderer: params => (
                //     <span className={params.value === 'Active' ? 'badge bg-success' : 'badge bg-danger'}>
                //         {params.value}
                //     </span>
                // ),
                cellRenderer: params => params.value === 'Active' ? <span className='active-status'>Active</span> : <span className='inactive-status'>Inactive</span>,
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
                width: 120
            },
            {
                field: 'ACTIONS',
                cellRenderer: AdminDesignationAction,
                cellRendererParams: {
                    bool: bool,
                    setBool: this.setBool,
                },
                autoHeight: true,
                pinned: 'right',
            }
        ];
        return (
            <>
            <div className="page-content">
                <Container fluid>
                    <div className='d-flex justify-content-between align-items-center'>
                        <h4 className="mb-0 font-size-18">Designation List</h4>
                       <Link to='/admin/add-designation'> <AddButton name={"ADD DESIGNATION"} /></Link>
                    </div>
                    <Row>
                        <Col xl='12' className='mt-2'>
                        {loading ?
                                <div className='dd-flex justify-content-center p-5'>
                                    <Loader />
                                </div> :
                            <DataTable 
                              rowData={designationList}
                              columnDefs={columnDefs}
                              height={'70vh'}
                            />}
                        </Col>
                    </Row>
                </Container>
                </div>
            </>
        )
    }
}

const mapStateToProps = state => ({
    designationList:  state?.AdminDesignationList?.data?.data,
    // departmentListRes: state.DepartmentListRes // Adjust based on where `departmentListRes` is stored
});

export default connect(mapStateToProps)(AdminDesignationList)
